<div *ngIf="latestUnread$ | async as latestUnread" @fadeInOut class="alert-wrapper">
  <div *ngIf="isMessageNotInAuthScreen$ | async">
    <div class="alert" [class.!hidden]="extended">
      <div class="message-container">
        <img class="alert-icon" *ngIf="latestUnread.type === MessageTypeEnum.Regular"
             src="assets/icons/icon-message.svg" alt="confirm"/>
        <img class="alert-icon" *ngIf="latestUnread.type === MessageTypeEnum.DeploymentSuccess"
             src="assets/icons/icon-warning-blue-big.svg" alt="info"/>
        <div>
          <div class="header">
            {{latestUnread.title}}
          </div>
          <div class="description">
            {{latestUnread.body}}
          </div>
          <div class="buttons" *ngIf="latestUnread.type === MessageTypeEnum.Regular">
            <app-button styleClass="settings"
              subStyle="blue"
              [minWidth]="0"
              (clicked)="readMore()"
            >
              Read more
            </app-button>
            <app-button customClasses="px-5"
              [minWidth]="0"
              [text]="'Got it'"
              (clicked)="gotIt(latestUnread.messageId)"
            ></app-button>
          </div>

          <div class="buttons" *ngIf="latestUnread.type === MessageTypeEnum.DeploymentSuccess">
            <app-button customClasses="px-5"
              [minWidth]="0"
              (clicked)="refresh()"
            >
              Refresh
            </app-button>
          </div>
       
        </div>
      </div>
    </div>
    <app-dialog *ngIf="extended"
      [show]="true"
      [showHeader]="true"
      [header]="latestUnread.title"
      [subHeader]="latestUnread.body"
      [headerIcon]="'warning'"
      headerIconName="icon-message-big"
      headerIconClasses="!pr-6"
      [minWidth]="720"
      [maxWidth]="720"
      [hideHeaderUnderline]="true"
    >
    <div style="margin-left: 4.5rem;">
      <app-button customClasses="px-5"
        [minWidth]="0"
        [text]="'Got it'"
        (clicked)="gotIt(latestUnread.messageId)"
      ></app-button>
    </div>
    </app-dialog>
  </div>
</div>
  